import { ROLE, type Role } from '@susu/customer-hub'

const ROLE_QUERY_PARAM = 'role'
const DEFAULT_ROLE: Role = ROLE.STYLE_ADVISOR
const SUPPORTED_ROLES: readonly Role[] = Object.values(ROLE)

/**
 * Customer Hub can boot as either role, but only this host app decides which.
 * Other hosts (Shopify storefront, ACL) pass the role as a prop instead, so the
 * query param is read here and nowhere inside @susu/customer-hub.
 */
export function getRole(search: string = window.location.search): Role {
  const role = new URLSearchParams(search).get(ROLE_QUERY_PARAM)?.trim()

  if (!role) {
    return DEFAULT_ROLE
  }

  const matchedRole = SUPPORTED_ROLES.find(
    (supportedRole) => supportedRole === role.toLowerCase(),
  )

  if (!matchedRole) {
    console.warn(
      `Unsupported "${ROLE_QUERY_PARAM}" query param "${role}". Falling back to "${DEFAULT_ROLE}". Supported values: ${SUPPORTED_ROLES.join(', ')}.`,
    )
    return DEFAULT_ROLE
  }

  return matchedRole
}
